import { Skeleton } from '@mui/material';
import React from 'react';
import * as Utility from '../../../core/utility';
import InstagramIcon1 from '../../../components/icons/instagram-icon1';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { InfluencerCampaignCard } from '../../../components';
import dayjs from 'dayjs';
import IconLocation from '../../../components/icons/icon-location';
import { DummyCampaignImage } from '../../../config/config';

interface Props {
  res: any;
  loading: Boolean;
  onClick: any;
  isMobile: any;
  campaign_id: any;
}
const methods: Utility.Methods = new Utility.Methods();

const CampaignCardDesktop = ({ res, loading, onClick, campaign_id }: Props) => {
  return (
    <div
      key={res?.campaign_id}
      className={`${campaign_id.campaign_id === res?.campaign_id
        ? 'dashboard-card active'
        : 'dashboard-card'
        }`}
      onClick={() => onClick(res)}
    >
      <div className='dashboard-card-left'>
        <img
          src={loading ? <Skeleton width={182} height={182} animation="wave" /> : res.campaign_cover_url && res.campaign_cover_url ? res.campaign_cover_url : DummyCampaignImage.default_campaign_image}
          alt=''
          style={{ cursor: 'pointer' }}
        />
        <div className={res.campaign_category && (res.campaign_category === 'Invited' || res.campaign_category === 'Private') ? 'campaign-cate-detail-mobile d-inline-flex d-md-none' : 'campaign-cate-detail-mobile d-inline-flex d-md-none'}>
          <span className='badge badge-primary-outline mb-2 mt-2 d-flex d-md-none'>
            {(res.campaign_platform + '').toLocaleLowerCase() === 'instagram' && (<InstagramIcon1 width="20px" height="20px" />)}
            {(res.campaign_platform + '').toLocaleLowerCase() === 'youtube' && (<YouTubeIcon style={{ color: '#f00', marginRight: '5px' }} />)}
            {loading ? <Skeleton animation="wave" /> : res.campaign_type}
          </span>
          {res.campaign_category && (res.campaign_category === 'Invited' || res.campaign_category === 'Private') &&
            <span style={{ order: res.campaign_category && (res.campaign_category === 'Invited' || res.campaign_category === 'Private') ? '-1' : '' }} className='badge badge-primary-black mb-2 mt-2 justify-self-start me-2'>Invited</span>}
        </div>
      </div>
      <div className='dashboard-card-right'>
        <div className='dashboard-card-right-top'>
          <div className='dashboard-card-right-top-left'>
            <span className='d-block color-blk-5d fs-14 mb-1'>
              Posted{' '}
              {methods.calculateDaysDifference(
                new Date(res?.posted_at),
                new Date()
              )}{' '}
              days ago
            </span>
            {(res?.reveal_brand_name === 'true') &&
                          <p className='mb-0'>{res?.brand_name}</p>
                        }

            <h3 className='dashboard-card-title'>
              {loading ? <Skeleton animation="wave" /> : res?.campaign_title}
            </h3>
          </div>

          <div className={res.campaign_category && (res.campaign_category === 'Invited' || res.campaign_category === 'Private') ? 'dashboard-card-right-top-right d-none d-md-flex ' : ''}>
            <span className='badge badge-primary-outline mb-2 mt-2 d-none d-md-flex'>
              {(res.campaign_platform + '').toLocaleLowerCase() === 'instagram' && (<InstagramIcon1 width="20px" height="20px" />)}
              {(res.campaign_platform + '').toLocaleLowerCase() === 'youtube' && (<YouTubeIcon style={{ color: '#f00', marginRight: '5px' }} />)}
              {loading ? <Skeleton animation="wave" /> : res.campaign_type}
            </span>
            {res.campaign_category && (res.campaign_category === 'Invited' || res.campaign_category === 'Private') &&
              <span style={{ order: res.campaign_category && (res.campaign_category === 'Invited' || res.campaign_category === 'Private') ? '-1' : '' }} className='badge badge-primary-black mb-2 mt-2 justify-self-start me-2'>Invited</span>}
          </div>
        </div>
        <InfluencerCampaignCard
          description={loading ? <Skeleton animation="wave" /> : res.campaign_description}
          about_brand={loading ? <Skeleton animation="wave" /> : res.about_brand}
          updated_at={loading ? <Skeleton animation="wave" /> : res.updated_at}
        />
        {/* BRAND_WEB_URL */}
        {res?.reveal_brand_name === 'true' && (
          <a
            href={
              res?.brand_web_url?.startsWith('http')
                ? res.brand_web_url
                : `https://${res.brand_web_url}`
            }
            target='_blank'
            rel='noopener noreferrer'
            className='text-decoration-none d-block text-wrap word-break'
            style={{ fontSize: '14px', fontWeight: 400 }}
          >
            {res?.brand_web_url}
          </a>
        )}
        {/* CAMPAIGN DELIVERABLES */}
        <div className='d-flex flex-wrap mb-2'>
          <>
            {res?.deliverables?.split(',').map((del: any) => {
              const trimmedDeliverable = del.trim();
              console.log('trimmedDeliverable', trimmedDeliverable);

              if (trimmedDeliverable !== '') {
                return (
                  <span
                    key={del}
                    className='badge badge-default me-2 mb-2'
                  >
                    {loading ? <Skeleton animation="wave" /> : trimmedDeliverable}
                  </span>
                );
              }
              return null;
            })}
          </>
        </div>
        {/* END CAMPAIGN DELIVERABLES */}
        {/* CAMPAIGN DURATION INFO */}
        <div className='dashboard-card-camp-dur'>
          <div className='infl-det-list-sec proposal-dur-info'>
            <div className='infl-det-list'>
              <div className='infl-det-list-icon d-none d-md-flex'>
                <span className="material-symbols-rounded">
                  alarm
                </span>
              </div>
              <div className='infl-det-list-content'>
                <strong className='d-none d-md-inline-flex'>
                  {res.influencer_gender}
                </strong>
                <ul>
                  <li>Gender<strong className='d-md-none ps-1'>{res.influencer_gender}</strong></li>
                </ul>
              </div>
            </div>
            <div className='infl-det-list'>
              <div className='infl-det-list-icon d-none d-md-inline-flex'>
                <span className="material-symbols-rounded">
                  alarm
                </span>
              </div>
              <div className='infl-det-list-content'>
                <strong className='d-none d-md-flex'>
                  {loading ? <Skeleton animation="wave" /> : dayjs(res?.proposal_dt).format('LL')}{' '}
                </strong>
                <ul>
                  <li><span className='d-none d-md-inline-flex'>Proposal</span> Deadline <span className='d-md-none'>{loading ? <Skeleton animation="wave" /> : dayjs(res?.proposal_dt).format('LL')}{' '}</span></li>
                </ul>
              </div>
            </div>
            <div className='infl-det-list  d-none d-md-inline-flex'>
              <div className='infl-det-list-icon'>
                <span className="material-symbols-rounded">
                  calendar_month
                </span>
              </div>
              <div className='infl-det-list-content'>
                <strong>
                  {loading ? <Skeleton animation="wave" /> : dayjs(res?.go_live_dt).format('LL')}{' '}
                </strong>
                <ul>
                  <li>Campaign Live Date</li>
                </ul>
              </div>
            </div>
            {res?.campaign_visibility && res?.campaign_visibility !== 'Private' &&
              <div className='infl-det-list d-none d-lg-flex'>
                <div className='infl-det-list-icon'>
                  <IconLocation />
                </div>
                <div className='infl-det-list-content'>
                  <strong>
                    {res?.campaign_locations
                      ? (() => {
                        const formattedLocations = methods.formatGroupLocations(res.campaign_locations);
                        const firstTwoLocations = formattedLocations.slice(0, 2).join('; ');

                        if (formattedLocations.length > 2) {
                          const moreLocationsCount = formattedLocations.length - 2;
                          return `${firstTwoLocations}, +${moreLocationsCount} more`;
                        }

                        return firstTwoLocations;
                      })()
                      : 'Default Value'}
                  </strong>
                  <ul>
                    <li>Location</li>
                  </ul>
                </div>
              </div>
            }
          </div>
          {res?.campaign_visibility && res?.campaign_visibility !== 'Private' &&
            <div className='infl-det-list d-none'>
              <div className='infl-det-list-icon'>
                <IconLocation />
              </div>
              <div className='infl-det-list-content'>
                <strong>
                  {res?.campaign_locations
                    ? (() => {
                      const locationsArray = res.campaign_locations.split(',');
                      const formattedLocations = locationsArray.map((location: any) =>
                        location
                          .split(':')
                          .map((part: string) => part.trim())
                          .filter(Boolean)
                          .join(', ')
                      );
                      const firstTwoLocations = formattedLocations.slice(0, 2).join('; ');

                      if (formattedLocations.length > 2) {
                        const moreLocationsCount = locationsArray.length - 2;
                        return `${firstTwoLocations}, +${moreLocationsCount} more`;
                      }

                      return firstTwoLocations;
                    })()
                    : 'Default Value'}
                </strong>
                <ul>
                  <li>Location</li>
                </ul>
              </div>
            </div>
          }
          <div className='d-flex align-items-baseline'>
            <button className='btn btn-primary mt-2 me-4 d-none d-md-inline-flex'>
              View details
            </button>
            {res.days_old >= 1 && (
              <span style={{ color: '#E50000' }} >
                Application Closed
              </span>
            )}
          </div>
        </div>
        {/* END CAMPAIGN DURATION INFO */}
      </div>
    </div>
  )
}

export default CampaignCardDesktop